import { render, staticRenderFns } from "./DesignateDriver.vue?vue&type=template&id=612983fb"
import script from "./DesignateDriver.vue?vue&type=script&lang=js"
export * from "./DesignateDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports